export default __webpack_public_path__ + "static/media/post-img1.156689ff.jpg";